import { bwColor } from '@fattureincloud/fic-design-system/dist/styles/types';

export const white: bwColor = {
  8: '#FFFFFF14',
  16: '#FFFFFF28',
  48: '#FFFFFF7A',
  80: '#FFFFFFCC',
  100: '#FFFFFF'
};
